import application from './application';

export default {
  application,
};
